import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=74cd66f4&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"
import style0 from "./WhyUs.vue?vue&type=style&index=0&id=74cd66f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cd66f4",
  null
  
)

export default component.exports